module.exports = __webpack_public_path__ + "static/media/ufo_bird.18685710.svg";